<app-modal-layout
    *transloco="let tSelectViews; read: 'select_views_options'"
    class="block w-full md:w-[35.5rem]"
    [containerLayout]="containerLayout"
    (closeModal)="forceWithValidation()"
>
    <ng-container title>{{ tSelectViews('select_views') }}</ng-container>
    <ng-container subtitle>{{ tSelectViews('select_views_description') }}</ng-container>
    <div class="flex flex-col my-3">
        @for (schema of data.schemas; track schema) {
            <div class="mb-1 subheading-2 text-text">{{ schema.name }}</div>
            <div class="flex max-xsm:flex-col max-xsm:gap-2 gap-4">
                @for (view of data.views[schema.id]; track view) {
                    @let viewControl = activeViewControl.controls[schema.id].controls[view.name];
                    <div
                        [class]="viewControl.value ? 'border-primary' : 'border-transparent'"
                        class="flex justify-between items-center flex-1 p-4 rounded-2xl border-2 border-solid shadow-md"
                    >
                        <div class="flex items-center">
                            <app-tb-icon [icon]="view.icon" class="mr-2"></app-tb-icon>
                            {{ tSelectViews(view.name) }}
                        </div>
                        <app-tb-toggle [formControl]="viewControl"></app-tb-toggle>
                    </div>
                }
            </div>
        }
    </div>
    <app-modal-layout-buttons
        buttons
        *transloco="let tButtons; read: 'buttons'"
        [primary]="true"
        [cancel]="true"
    >
        <app-tb-button primary (click)="goBack()" [appearance]="'outlined'" class="mr-4">
            {{ tButtons('cancel') }}
        </app-tb-button>
        <app-tb-button cancel (click)="applyChanges()"> {{ tButtons('apply') }}</app-tb-button>
    </app-modal-layout-buttons>
</app-modal-layout>
